import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalComponent from '../common/ModalComponent/ModalComponent'; // Adjust path as needed
import { useTranslation } from "react-i18next";

const TOKEN_EXPIRATION = 30 * 60 * 1000; // 30 minutes
const IDLE_TIMEOUT = TOKEN_EXPIRATION - (5 * 60 * 1000); // 25 minutes idle triggers modal

const IdleLogout = ({ children }) => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setIsModalOpen(true);
    }, IDLE_TIMEOUT);
  };

  const handleSubmit = () => {
    setIsModalOpen(false);
    localStorage.clear();
    navigate('/login'); // Redirect to login page
  };

  const closeModal = () => {
    setIsModalOpen(false);
    resetTimer(); // Restart timer if user cancels
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'scroll', 'click'];
    const handleActivity = () => {
      resetTimer();
    };

    events.forEach(event => window.addEventListener(event, handleActivity));
    resetTimer();

    return () => {
      events.forEach(event => window.removeEventListener(event, handleActivity));
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <>
      {children}
      <ModalComponent
        modalTitle={t("sessionTimeoutWarning")}
        isOpen={isModalOpen}
        modalText={t("loggedOutInactivityMessages")}
        modalType="Warning"
        onClose={closeModal}
        fieldsData={[]}
        formData={[]}
        onChangeInput={() => {}}
        buttons={[
          <button className="saveButton" onClick={handleSubmit} key="submit">
            {t("yesLogout")}
          </button>,
          <button className="cancelButton" onClick={closeModal} key="cancel">
            {t("noStayLoggedIn")}
          </button>
        ]}
      />
    </>
  );
};

export default IdleLogout;

